"use client";

import React from "react";

//Types
import { CountShowPageProps } from "@/types";

//Styles
import * as S from "./styles";

const CountPage: React.FC<CountShowPageProps> = ({
  dict,
  currentPage,
  showCurrent,
  pages,
  startItem,
  totalItems,
}) => {
  if (startItem !== undefined && totalItems !== undefined) {
    return (
      <S.BoxCountPage>
        {dict.Showing} {startItem} {dict.to} {showCurrent} {dict.of}{" "}
        {totalItems} {dict.results}
      </S.BoxCountPage>
    );
  }

  // Fallback
  return (
    <S.BoxCountPage>
      {dict.Showing} {currentPage} {dict.to} {showCurrent} {dict.of}{" "}
      {pages.length} {dict.results}
    </S.BoxCountPage>
  );
};

export default CountPage;
